// extracted by mini-css-extract-plugin
export default {"container":"LoaderWrapper_container__xezIo","loader":"LoaderWrapper_loader__Xoejs","spin":"LoaderWrapper_spin__DRViK"};